<!-- Delete Modal -->
<div class="delete-model-wrapper">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!--  <div class="modal-header border-0">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> 
      </div> -->
      <div class="modal-body flex-center-all flex-column pt-5">
        <svg
          width="99"
          height="99"
          viewBox="0 0 99 99"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="49.5"
            cy="49.5"
            r="49.5"
            fill="#FF204C"
            fill-opacity="0.12" />
          <path
            d="M60.135 63.26H44.75L28.3875 79.6225C28.8337 79.7075 29.3012 79.75 29.7687 79.75H68.2312C72.2687 79.75 75.5625 76.4562 75.5625 72.4187V39.3325H68.6775L60.135 47.875C61.3037 47.875 62.26 48.8312 62.26 50C62.26 51.1687 61.3037 52.125 60.135 52.125H55.885L49 59.01H60.135C61.3037 59.01 62.26 59.9662 62.26 61.135C62.26 62.3037 61.3037 63.26 60.135 63.26ZM75.1226 20.8726L67.2814 28.7139L64.1512 25.8387L59.3275 21.4187V32.0225C59.3275 33.2677 60.0882 34.3451 61.1741 34.8211L58.1035 37.8917C56.9137 37.0404 56.0133 35.8449 55.5237 34.4662C55.2248 33.6864 55.0735 32.8577 55.0775 32.0225V20.25H29.7687C25.7312 20.25 22.4375 23.5437 22.4375 27.5812V72.4187C22.4375 72.7715 22.5119 73.0987 22.5607 73.4345L19.8726 76.1226C19.6697 76.3186 19.5078 76.5531 19.3964 76.8124C19.285 77.0716 19.2264 77.3505 19.224 77.6326C19.2215 77.9148 19.2753 78.1946 19.3821 78.4558C19.489 78.7169 19.6468 78.9542 19.8463 79.1537C20.0458 79.3532 20.2831 79.511 20.5442 79.6179C20.8054 79.7247 21.0852 79.7785 21.3673 79.776C21.6495 79.7736 21.9283 79.715 22.1876 79.6036C22.4469 79.4922 22.6813 79.3303 22.8774 79.1274L78.1274 23.8774C78.3303 23.6813 78.4922 23.4469 78.6036 23.1876C78.715 22.9283 78.7736 22.6495 78.776 22.3673C78.7785 22.0852 78.7247 21.8054 78.6179 21.5442C78.511 21.2831 78.3532 21.0458 78.1537 20.8463C77.9542 20.6468 77.7169 20.489 77.4558 20.3821C77.1946 20.2753 76.9148 20.2215 76.6326 20.224C76.3505 20.2264 76.0716 20.285 75.8124 20.3964C75.5531 20.5078 75.3186 20.6697 75.1226 20.8726ZM42.4762 52.125H37.865C36.6962 52.125 35.74 51.1687 35.74 50C35.74 48.8312 36.6962 47.875 37.865 47.875H42.4762C43.645 47.875 44.6012 48.8312 44.6012 50C44.6012 51.1687 43.645 52.125 42.4762 52.125ZM49 40.99H37.865C36.6962 40.99 35.74 40.0337 35.74 38.865C35.74 37.6962 36.6962 36.74 37.865 36.74H49C50.1687 36.74 51.125 37.6962 51.125 38.865C51.125 40.0337 50.1687 40.99 49 40.99Z"
            fill="#FF204C" />
        </svg>

        <div class="my-4 text-center">
          <h5 class="text-black">
            {{ translationKey | translate }}
          </h5>
        </div>
      </div>
      <div class="modal-footer border-0 mx-auto">
        <button
          type="button"
          class="primary-button me-2"
          (click)="deleteAction()">
          <span>{{ 'shared.yes' | translate }}</span>
        </button>

        <button
          type="
            button"
          class="secondary-button"
          (click)="close()">
          {{ 'shared.no' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
